<template>
	<div class="custom-expression-display">
        

        <div class="result"> <span> {{prettyResult}} </span></div>
        <!-- <input :placeholder="$t('custom-expression-editor.expression-ph')"/> -->
        

        <div class="operator-options">
            
            <div v-if="expressionObject.type == 'Text'"> Tekst

                <div class="text-options">

                    <button>Er lig med</button> 
                    <button>Ikke lig med</button> 

                </div>

            </div>
            <div v-if="expressionObject.type == 'Number'">Tal 

                <div class="number-options">

                    <button>Er lig med</button> 
                    <button>Ikke lig med</button> 
                    <input :placeholder="'Er mellem'"/>

                </div>

            </div>

             <div v-if="expressionObject.type == 'Date'"> Dato

                <div class="date-options">

                    <button>Er lig med</button> 
                    <button>Ikke lig med</button> 
                    <button>Før</button> 
                    <button>Eter</button> 

                </div>

            </div>


        </div>


	</div>
</template>

<script>
	export default {
		props: {
            expressionObject: Object
		},
		data () {
			return {
			
			}
		},
		computed: {
			prettyResult(){
                return this.expressionObject.displayName
            }
		},
		methods: {
			
		},
		components: {
	
		}
	}
</script>

<style lang="less">

	

</style>
